import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from '../../../classes/User';
import { UserService } from '../../../services/user/user.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { Roles } from 'src/app/enums/Roles';

@Component({
  selector: 'app-user-edit',
  styleUrls: ['./user-edit.component.scss'],
  templateUrl: './user-edit.component.html',
  encapsulation: ViewEncapsulation.None
})
export class UserEditComponent implements OnInit {

  @Input() user: User;

  destroy = new Subject<any>();
  currentDialog = null;
  errorMessage: string;
  groups = [];
  roleOptions: string[] = [];
  public currentUser: any;
  public roles = Roles;

  public userForm: FormGroup;

  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private localStorageService: LocalStorageService) {
    this.currentUser = this.localStorageService.getUser();
  }

  ngOnInit(): void {
    this.userService.getRoles().subscribe({
      next: (roles: string[]) => {
        this.roleOptions = roles;
      }
    });
    if (this.user) {
      this.userForm = this.formBuilder.group({
        id: [this.user.id],
        firstName: [this.user.firstName, Validators.required],
        lastName: [this.user.lastName, Validators.required],
        phone: [this.user.phone.value, Validators.required],
        email: [this.user.email.value, Validators.required],
        roles: [this.user.roles, Validators.required],
      });
    } else {
      this.userForm = this.formBuilder.group({
        id: [''],
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        phone: ['', Validators.required],
        email: ['', Validators.required],
        roles: [[], Validators.required],
      });
    }
  }

  closeModal(sendData): void {
    this.activeModal.close(sendData);
  }
}
